'use strict';

/* globals RELATIVE_PATH, document, $, bootbox */

require([RELATIVE_PATH + '/plugins/nodebb-plugin-surveys/static/vendor/vue.js'], function (Vue) {
	Vue.component('survey-questions', {
		props: ['initData'],
		data: function () {
			return {
				questions: this.initData.questions,
				answers: this.initData.answers,
				currentQuestion: 0
			}
		},
		computed: {
			question: function () {
				return this.questions[this.currentQuestion];
			}
		},
		mounted: function () {
			this.initQuestion();
		},
		methods: {
			initQuestion: function () {
				this.initData.askedQuestions += 1;
			},
			answered: function (weight) {
				this.answers.push({ id: this.question.id, answer: weight });

				this.nextQuestion();
			},
			nextQuestion: function () {
				if (this.currentQuestion + 1 >= this.questions.length) {
					this.initData.isCompleted = true;
					this.submitAnswers();

					return;
				}

				this.canGoNext = false;
				this.currentQuestion += 1;

				this.initQuestion();
			},
			submitAnswers: function () {
				socket.emit('plugins.surveys.submitAnswers', { surveyId: this.initData.surveyId, answers: this.answers });
			}
		},
		template: 
		'<div>' +
			'<survey-question :question="question" :answered="answered"></survey-question>' +
		'</div>',
	});
});
